module.exports = __webpack_public_path__ + "static/media/contact.2dee2361.svg";